/**
 * The film pages' entry: one script for every film (`sheds/film/index.html` and each
 * page beside it), choosing its film by the path it was opened at.
 *
 * The site's header and footer (`site.css`), the shared controls (`controls.css`) and the
 * page's own layout (`film.css`) — and nothing of the configurator: a film is a canvas
 * and a clock, with no engine, renderer or PDF writer behind it.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { ErrorBoundary } from "../analytics/ErrorBoundary.js";
import { startErrorReporting } from "../analytics/sentry.js";
import { PRICE } from "../purchase/price.js";
import { BRAND } from "../site/nav.js";
import { planType } from "../site/planTypes.js";
import { FilmPage } from "./FilmPage.js";
import { FILMS, filmAt } from "./films.js";
import { paletteFrom } from "./palette.js";
import "../styles/tokens.css";
import "../styles/site.css";
import "../styles/controls.css";
import "../styles/film.css";

startErrorReporting();

const container = document.getElementById("root");
if (container === null) {
  throw new Error("no #root in index.html");
}

const path = window.location.pathname.replace(/\/?$/, "/");
const entry = filmAt(path) ?? FILMS[0];
if (entry === undefined) {
  throw new Error(`no film at ${path}`);
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <FilmPage
        type={planType(entry.type)}
        path={entry.path}
        kind={entry.kind}
        film={entry.film}
        palette={paletteFrom(getComputedStyle(document.documentElement))}
        site={{ brand: BRAND, price: PRICE, host: __SITE_HOST__ }}
      />
    </ErrorBoundary>
  </StrictMode>,
);
